/**
 * Delivery status constants - mirrors ReservationDeliveryInfo status constants from backend.
 *
 * These represent the internal WeWelcom delivery workflow statuses:
 * PENDING → ACCEPTED → PREPARING → REVIEW → READY_FOR_PICKUP → PICKED_UP → DELIVERED
 */
export const DELIVERY_STATUS = {
	PENDING: 0,
	ACCEPTED: 1,
	PREPARING: 2,
	REVIEW: 3,
	READY_FOR_PICKUP: 4,
	PICKED_UP: 5,
	DELIVERED: 100,
	CANCELLED: -1,
};

export const DELIVERY_STATUS_LABELS = {
	[DELIVERY_STATUS.PENDING]: 'Pendiente',
	[DELIVERY_STATUS.ACCEPTED]: 'Aceptado',
	[DELIVERY_STATUS.PREPARING]: 'Preparando',
	[DELIVERY_STATUS.REVIEW]: 'Revisión',
	[DELIVERY_STATUS.READY_FOR_PICKUP]: 'Listo para recoger',
	[DELIVERY_STATUS.PICKED_UP]: 'Recogido',
	[DELIVERY_STATUS.DELIVERED]: 'Entregado',
	[DELIVERY_STATUS.CANCELLED]: 'Cancelado',
};
